import { Component, input } from '@angular/core';

@Component({
  selector: 'app-badge',
  template: `
    <span
      class="badge rounded-full w-fit font-semibold truncate"
      [class]="badgeClass">
      {{ getValue() }}
    </span>
  `,
})
export class Badge {
  value = input.required<string>();
  size = input<string>('md');

  get badgeClass(): string {
    return `${this.getSize()} ${this.getColor()}`;
  }

  getValue(): string {
    switch (this.value()) {
      case 'junior':
        return 'Junior';
      case 'easy':
        return 'Easy';
      case 'mid':
        return 'Middle';
      case 'medium':
        return 'Medium';
      case 'senior':
        return 'Senior';
      case 'hard':
        return 'Hard';
      case 'pending':
        return 'Pending';
      case 'completed':
        return 'Completed';
      case 'started':
        return 'In Progress';
      case 'expired':
        return 'Expired';
      default:
        return this.value();
    }
  }

  getSize(): string {
    switch (this.size()) {
      case 'sm':
        return 'badge-sm';
      case 'lg':
        return 'badge-lg font-semibold';
      case 'xl':
        return 'badge-xl';
      default:
        return 'badge-md';
    }
  }

  getColor(): string {
    switch (this.value()) {
      case 'junior':
      case 'easy':
      case 'completed':
        return 'bg-emerald-100 text-emerald-700 border border-emerald-200';
      case 'mid':
      case 'medium':
      case 'started':
        return 'bg-amber-100 text-amber-700 border border-amber-200';
      case 'senior':
      case 'hard':
      case 'expired':
        return 'bg-red-100 text-red-700 border border-red-200';
      case 'pending':
        return 'bg-gray-100 text-gray-700 border border-gray-200';
      default:
        return 'bg-blue-100 text-blue-700 border border-blue-200';
    }
  }
}
